import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  listContainer: {
    width: "100%",
    maxWidth: 323,
    backgroundColor: "#e6e6e6",
    borderBottomLeftRadius: "8px"
  },
  absoluteSContainer: {
    top: "56px",
    position: "absolute",
    background: "lightgrey",
    width: "100%",
    minHeight: "200px",
    color: "#727272",
    justifyContent: "center",
    display: "flex",
    backgroundColor: "#f3f3f3",
    zIndex: 2,
    left: 0,
    right: 0,
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "960px",
    boxShadow:
      "0 2px 4px -1px rgb(0 0 0 / 20%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 4px 5px 0 rgb(0 0 0 / 14%)",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px"
  },
  textItem: {
    "& >span": {
      fontWeight: "normal",
      fontSize: 15,
      lineHeight: "17px"
    }
  },
  itemMenu: {
    minHeight: 50,
    padding: "0 12px",
    "&.Mui-selected": {
      backgroundColor: "#f3f3f3"
    },
    "&.Mui-selected .MuiListItemText-root .MuiTypography-root": {
      color: "#00338d",
      fontWeight: "bold"
    }
  },
  navContainer: {
    paddingTop: 0,
    paddingBottom: 0
  },
  planMenuContainer: {
    height: "100%",
    width: 670
  },
  titleMenu: {
    fontSize: "18px",
    fontWeight: 300,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.28px",
    color: "#00338d",
    marginBottom: "15px"
  },
  cardContainer: {
    display: "flex",
    flexWrap: "wrap"
  },
  cardContainerServices: {
    display: "flex",
    flexWrap: "wrap"
  },
  cardMegaMenu: {
    position: "relative",
    width: "160px",
    height: "270px",
    margin: "0 10px 0 0",
    borderRadius: "8px",
    transition: " transform 300ms ease 0ms",
    backgroundColor: "#ffffff",
    cursor: "pointer"
  },
  cardServicesMenu: {
    position: "relative",
    width: "215px",
    height: "154px",
    borderRadius: "8px",
    marginRight: "10px",
    marginBottom: "20px",
    transition: " transform 300ms ease 0ms",
    backgroundColor: "#ffffff",
    cursor: "pointer"
  },
  cardBuyMenu: {
    width: "300px",
    height: "280px",
    background: "#0083c6",
    cursor: "default"
  },
  cardClinic: {
    width: 205,
    height: 270
  },
  cardImageContainer: {
    position: "relative"
  },
  image: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    width: "100%",
    height: "auto"
  },
  titleImage: {
    position: "absolute",
    left: "10px",
    bottom: "10px",
    fontSize: "22px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.34px",
    color: "rgba(255, 255, 255, 0.87)",
    width: "168px",
    fontFamily: "Trebuchet"
  },
  titleImageServices: {
    position: "absolute",
    left: "10px",
    bottom: "10px",
    fontSize: "18px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.34px",
    color: "rgba(255, 255, 255, 0.87)",
    width: "168px",
    fontFamily: "Trebuchet"
  },
  descriptionImage: {
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#727272",
    padding: "0 10px",
    marginTop: "5px",
    fontFamily: "Trebuchet"
  },
  arrowContainer: {
    position: "absolute",
    bottom: "0px",
    right: "0px"
  },
  arrowIcon: {
    fontSize: "26px",
    fontWeight: 700
  },
  colorPurple: {
    color: "#8331a7"
  },
  iconSize: {
    fontSize: 18,
    fontWeight: "bold"
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: 15
  },
  buttonStyles: {
    width: "200px",
    height: "40px",
    borderRadius: "4px",
    backgroundColor: "#e61d2f",
    fontSize: "14px",
    fontWeight: 800,
    color: "#ffffff",
    border: "none",
    bottom: "-20%",
    textTransform: "none"
  },
  buttonBuy: {
    borderRadius: "4px",
    backgroundColor: "transparent",
    fontSize: "14px",
    fontWeight: 600,
    color: "#ffffff",
    border: "2px solid",
    padding: "10px 40px",
    textDecoration: "none"
  },
  linkStyle: {
    "&:hover": {
      textDecoration: "none !important"
    }
  },
  iconActive: {
    fontWeight: 500,
    fill: "#0073cf",
    fontSize: "16px"
  },
  titleMedicalAssistence: {
    fontSize: "15px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.07",
    letterSpacing: "normal",
    color: "#00338d",
    marginBottom: "3px"
  },
  descriptionMedicalAssistence: {
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.08",
    letterSpacing: "-0.19px",
    color: "#727272",
    marginBottom: "3px"
  },
  colorGris: {
    color: "#e7e7e7"
  },
  cardMedicalAssistenceContainer: {
    width: "260px",
    height: "75px",
    margin: "0 10px 10px 0",
    padding: "7px 0 5px 12px",
    borderRadius: "2px",
    backgroundColor: "#fafafa",
    position: "relative",
    fontFamily: "Trebuchet",
    textDecoration: "none !important",
    "&:hover": {
      transform: "translateX(0px) translateY(-5px)!important",
      boxShadow:
        "0 2px 4px -1px rgb(0 0 0 / 20%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 4px 5px 0 rgb(0 0 0 / 14%)",
      transition: "transform 300ms ease 0ms",
      "& $colorGris": {
        color: theme.palette.primary.dark
      }
    }
  },
  headermenuAsistenciaMedica: {
    display: "flex",
    alignItems: "center",
    fontFamily: "'Trebuchet','Trebuchet MS',Helvetica,Arial,Lucida,sans-serif",
    borderRadius: "8px",
    boxShadow:
      "0 2px 4px -1px rgb(0 0 0 / 20%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 4px 5px 0 rgb(0 0 0 / 14%)",
    backgroundColor: "#ffffff",
    marginBottom: "15px",
    position: "relative",
    color: "#727272",
    width: "550px",
    textDecoration: "none !important",
    "&:hover": {
      "& $colorGris": {
        color: theme.palette.primary.dark
      }
    }
  },
  imagenmenuAsistenciaMedica: {
    position: "relative",
    width: "251px",
    height: "102px",
    display: "inline-table"
  },
  textoimgmenuAsistenciaMedica: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    color: "rgba(255,255,255,0.87)",
    fontSize: "18px",
    fontWeight: "bold",
    textShadow: "0 1px 1px rgb(0 0 0 / 80%)",
    textAlign: "right"
  },
  descripcionHeadermenuasistenciaMedica: {
    padding: "10px 15px",
    fontSize: "14px",
    lineHeight: "1.2em"
  },
  bannerImage: {
    height: "100%"
  },

  //MEGA MENU2.0
  amMainContainerMegaMenu: {
    fontFamily: "Trebuchet",
    height: "100%"
  },
  amContainerHeaderMegaMenu: {
    display: "flex",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: "100%",
    minHeight: "100px"
  },
  amHeaderMegaMenu: {
    paddingTop: "12px",
    paddingBottom: "12px",
    paddingLeft: "25px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  tituloContenedorCoberturaMegaMenu: {
    textShadow: "0 1px 1px rgb(0 0 0 / 80%)",
    fontSize: "18px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "0.83",
    letterSpacing: "-0.38px",
    color: "#ffffff",
    marginBottom: "13px"
  },
  subtituloContenedorCoberturaMegaMenu: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.21",
    letterSpacing: "normal",
    color: "#ffffff"
  },
  amDescriptionMegaMenu: {
    display: "flex",
    backgroundColor: "#f3f3f3",
    padding: "25px",
    justifyContent: "space-between",
    minHeight: "160px",
    borderBottomRightRadius: "8px"
  },
  amContenedoresMegaMenu: {
    display: "flex",
    flexDirection: "column",
    marginRight: "10px"
  },
  tituloDescripcionAmMegaMenu: {
    fontSize: "15px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.07",
    letterSpacing: "normal",
    color: "#00338d"
  },
  amNormalMarginMegaMenu: {
    fontWeight: "normal",
    marginTop: "10px",
    textDecoration: "none",
    width: "fit-content"
  },
  lineaDivisorCanalesServicios: {
    height: "146px",
    margin: "0 19.5px",
    border: "solid 0.9px #cfcfcf"
  },
  linkAmMegaMenu: {
    textDecoration: "none",
    marginBottom: "15px",
    maxWidth: "260px"
  },
  descripcionTarjetaAsistenciaMedica: {
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.08",
    letterSpacing: "-0.19px",
    color: "#727272",
    marginBottom: "3px",
    paddingRight: "20px",
    paddingTop: "3px"
  },
  botonesCoberturaMegaMenu: {
    backgroundColor: "rgba(0,115,207,0.4)",
    width: "140px",
    textAlign: "center",
    padding: "13px 0",
    borderRadius: "8px",
    border: "solid 1px #ffffff",
    display: "flex",
    justifyContent: "center",
    textDecoration: "none",
    fontSize: "14px"
  },
  amBotonMegaMenuCeleste: {
    border: "solid 1px #00338d",
    backgroundColor: "#e1f8ff",
    color: "#00338d",
    fontWeight: "bold",
    width: "160px"
  },
  amBotonMegaMenuMorado: {
    border: "solid 1px #8331a7",
    color: "#8331a7",
    backgroundColor: "transparent",
    marginTop: "10px",
    width: "160px"
  },
  condicionesTextAmMegaMenu: {
    fontSize: "8px!important",
    paddingRight: "0!important",
    marginTop: "auto",
    textAlign: "center"
  },
  coberturaEcuadorMegaMenu: {
    display: "flex",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    minHeight: "210px",
    width: "100%",
    fontFamily: "Trebuchet",
    height: "inherit"
  },
  megaMenuMedicaMundial: {
    display: "flex",
    alignItems: "center",
    paddingLeft: "70px",
    paddingRight: "50px",
    width: "100%",
    justifyContent: "space-between"
  },
  megaMenuCoberturaFrenteCancer: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "unset",
    paddingTop: "25px",
    paddingLeft: "50px"
  },
  tituloMegaMenuOncocare: {
    fontSize: "30px",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#ffffff",
    marginBottom: "10px"
  },
  botonesCoberturaFrenteCancerMegaMenu: {
    border: "solid 1px #ffffff",
    backgroundColor: "transparent",
    color: "#ffffff",
    marginTop: "30px",
    alignSelf: "flex-end"
  }
}));

export default styles;
